import { IUser } from "../../models/user";
import { UserState } from "../states/user";
import { UserActions, EUserActions } from "../actions/user";

export function UserReducers(
  state: IUser = UserState,
  action: UserActions,
): IUser {
  switch (action.type) {
    case EUserActions.LoginAttempt: {
      return {
        ...state,
        authenticated: false,
        authenticating: true,
        errors: [],
      };
    }
    case EUserActions.LoginAttemptSuccess: {
      return {
        ...state,
        data: action.payload.data,
        me: null,
        authenticated: action.payload.authenticated,
        authenticating: action.payload.authenticating,
        errors: action.payload.errors,
      };
    }
    case EUserActions.LoginAttemptFailed: {
      return {
        ...state,
        data: null,
        me: null,
        authenticated: action.payload.authenticated,
        authenticating: action.payload.authenticating,
        errors: action.payload.errors,
      };
    }

    case EUserActions.Logout: {
      return {
        ...state,
      };
    }

    case EUserActions.LoginOtpRequired: {
      return {
        ...state,
        authenticating: false,
        otp: action.payload,
      };
    }

    case EUserActions.MeRequestOK: {
      return {
        ...state,
        authenticating: action.payload.authenticating,
        authenticated: action.payload.authenticated,
        me: action.payload.me,
      };
    }
    default:
      return state;
  }
}
